import React from "react";
import { Checkbox, PortalFormDescription, PortalFormFieldGroup, PortalFormLabel, portalColors } from "src/components";
import Skeleton from "src/scenes/Statistics/components/Skeleton";
import styled from "styled-components";
import { SurveyStatusType } from "src/constants/survey";

const CheckboxContainer = styled.div`
    display: flex;
    align-items: center;
`;

const AnonymousConsentLabel = styled.label`
    display: flex;
    align-items: flex-start;
    gap: 0.75rem;
    cursor: ${p => p.$disabled ? "not-allowed" : "pointer"};
`;

const AnonymousFieldGroup = styled(PortalFormFieldGroup)`
    padding-bottom: 1rem;

    > label,
    > p {
        margin-top: 1.25rem;
    }
`;

export const SurveySubmissionAnonymousField = (props) => {
    const { setSurveyAnonymous, surveyIsAnonymous, surveyStatus, isEditSurveyForm, loading } = props;

    return (
        <AnonymousFieldGroup>
            <PortalFormLabel>
                Make Survey Submission Anonymous (Optional)
            </PortalFormLabel>
            { loading ?
                <Skeleton animation="wave" width="32px" height="32px" />
                :
                <CheckboxContainer>
                    <AnonymousConsentLabel $disabled={surveyStatus !== SurveyStatusType.SCHEDULED && isEditSurveyForm}>
                        { surveyStatus !== SurveyStatusType.SCHEDULED && isEditSurveyForm ?
                            <Checkbox
                                color={surveyIsAnonymous ? portalColors.border : "#36be24" }
                                height="32px"
                                width="32px"
                                padding="7px"
                                value={true}
                                checked={surveyIsAnonymous}
                                disabled
                            />
                            :
                            <Checkbox
                                color="#36be24"
                                height="32px"
                                width="32px"
                                padding="7px"
                                value={true}
                                checked={surveyIsAnonymous}
                                onChange={ (e) => setSurveyAnonymous(e.target.checked) }
                            />
                        }
                        <PortalFormDescription as="span" margin="0">
                            By checking this box, all survey responses will be collected anonymously,
                            allowing users to share their thoughts freely without any personal identifiers.
                            Once the survey becomes active, this setting cannot be changed,
                            so make sure to decide before proceeding to promote candid and unbiased feedback.
                        </PortalFormDescription>
                    </AnonymousConsentLabel>
                </CheckboxContainer>
            }
        </AnonymousFieldGroup>
    );
};
